import { PATHNAMES } from 'constants/constants';
import { WORKFLOWS } from './types';

export type HeaderWorkflow = { type: WORKFLOWS; title: string; link: string };

export const legacyWorkflows: HeaderWorkflow[] = [
  {
    type: WORKFLOWS.INFRINGEMENT_DETECTION,
    title: 'Infringement Detection (Legacy)',
    link: PATHNAMES.infringementDetection,
  },
  { type: WORKFLOWS.CONCEPT_SEARCH, title: 'Concept Search', link: PATHNAMES.aiSearchV2 },
  { type: WORKFLOWS.AI_SEARCH, title: 'AI Search', link: PATHNAMES.aiSearch },
  {
    type: WORKFLOWS.FTO,
    title: 'FTO',
    link: PATHNAMES.fto,
  },
];

export const developerTools: HeaderWorkflow[] = [
  { type: WORKFLOWS.ORG_MANAGEMENT, title: 'Organisation Management', link: PATHNAMES.orgAdminPanel },
  { type: WORKFLOWS.PLATFORM_MANAGEMENT, title: 'Platform Management', link: PATHNAMES.platformAdminPanel },
  { type: WORKFLOWS.FEATURES_FLAGS_VIEW, title: 'View Features Flags', link: PATHNAMES.featureFlagsPanel },
  { type: WORKFLOWS.DEVELOPER_MANAGEMENT, title: 'Developer Management', link: PATHNAMES.developerAdminPanel },
  { type: WORKFLOWS.DEVELOPER, title: 'Developer Tools', link: PATHNAMES.developerPanel },
  { type: WORKFLOWS.CONFERENCE_MANAGEMENT, title: 'Conference Management', link: PATHNAMES.conferenceAdminPanel },
];
